import type { DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { AutoSkeleton } from '@/components/Skeleton'
import {
  WizardContentHeader,
  WizardContentHeaderDescription,
  WizardContentHeaderKicker,
  WizardContentHeaderTitle,
} from '@/components/Wizard'

interface DraftJobWizardContentHeaderContainerProps {
  vm: DraftJobViewModel
  titleId?: string
  title: ReactNode
  description?: ReactNode
  isSkeleton: boolean
  kickerTestId?: string
  titleTestId?: string
  descriptionTestId?: string
}

/**
 * Draft Job Wizard Content Header Container
 */
export const DraftJobWizardContentHeaderContainer = observer(
  function DraftJobWizardContentHeaderContainer({
    vm,
    title,
    titleId,
    description,
    isSkeleton,
    kickerTestId,
    titleTestId,
    descriptionTestId,
  }: DraftJobWizardContentHeaderContainerProps) {
    return (
      <WizardContentHeader>
        <WizardContentHeaderKicker testId={kickerTestId}>
          <AutoSkeleton isSkeleton={isSkeleton}>
            {vm.outlineVm.progress.currentStep} of {vm.outlineVm.progress.total}
          </AutoSkeleton>
        </WizardContentHeaderKicker>
        <WizardContentHeaderTitle id={titleId} testId={titleTestId}>
          <AutoSkeleton isSkeleton={isSkeleton}>{title}</AutoSkeleton>
        </WizardContentHeaderTitle>
        <WizardContentHeaderDescription testId={descriptionTestId}>
          <AutoSkeleton isSkeleton={isSkeleton}>{description}</AutoSkeleton>
        </WizardContentHeaderDescription>
      </WizardContentHeader>
    )
  },
)
